var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHeartSolid = function SvgHeartSolid(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.57 4.43a8.24 8.24 0 0 0-6.39-2.41c-2.1.13-4.05 1.13-5.53 2.62l-.62.62-.28 1.44h-1.5l-.28-1.44-.62-.62c-1.49-1.49-3.43-2.49-5.53-2.62-2.41-.15-4.7.72-6.39 2.41S-.13 8.41.02 10.82c.13 2.1 1.13 4.05 2.62 5.53l13.23 13.23c.08.08.2.08.28 0l13.23-13.23c1.49-1.49 2.49-3.44 2.62-5.53.13-2.42-.74-4.7-2.43-6.39"
  })));
};
export default SvgHeartSolid;